import axios from "axios";
import { toast } from "sonner";
import { askForPremium } from "./askPremium";
import { showAgeGateExternally } from "./ageGateBus";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("dtm_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Any 403 "premium_required" from the backend triggers the upgrade modal.
// A 403 "email_not_verified" means the member has not confirmed their email yet (only when that is switched on).
api.interceptors.response.use(
  (r) => r,
  (err) => {
    const detail = err?.response?.data?.detail;
    if (err?.response?.status === 403 && detail === "premium_required") {
      askForPremium("This is a premium feature");
    }
    // A 403 "age_required" means an explicit song was asked for by someone who has not passed the 18+ check.
    if (err?.response?.status === 403 && detail === "age_required") {
      showAgeGateExternally(null);
    }
    if (err?.response?.status === 403 && detail === "email_not_verified") {
      toast.error("Please confirm your email first. We sent you a link. You can ask for another at the top of the page.", { id: "email-not-verified" });
    }
    return Promise.reject(err);
  }
);

export default api;
